import ih from 'immutability-helper';

import * as types from './types';
import * as actionTypes from './actionTypes';
import initialState from './initialState';

const handleFetchUserIntegrationAccountsRequest = (
  state: types.VersionControlState,
) =>
  ih(state, {
    userIntegrationAccounts: {
      $merge: { isLoading: true, error: '', data: null },
    },
  });

const handleFetchUserIntegrationAccountsSuccess = (
  state: types.VersionControlState,
  action: types.FetchUserIntegrationAccountsSuccessAction,
) =>
  ih(state, {
    userIntegrationAccounts: {
      $merge: { isLoading: false, data: action.payload.data },
    },
  });

const handleFetchUserIntegrationAccountsError = (
  state: types.VersionControlState,
  action: types.FetchUserIntegrationAccountsErrorAction,
) =>
  ih(state, {
    userIntegrationAccounts: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleCreateUserIntegrationAccountRequest = (
  state: types.VersionControlState,
) =>
  ih(state, {
    createUserIntegrationAccount: {
      $merge: { isLoading: true, error: '' },
    },
  });

const handleCreateUserIntegrationAccountSuccess = (
  state: types.VersionControlState,
) =>
  ih(state, {
    createUserIntegrationAccount: {
      $merge: { isLoading: false, error: '' },
    },
  });

const handleCreateUserIntegrationAccountError = (
  state: types.VersionControlState,
  action: types.CreateUserIntegrationAccountErrorAction,
) =>
  ih(state, {
    createUserIntegrationAccount: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleUpdateUserIntegrationAccountRequest = (
  state: types.VersionControlState,
) =>
  ih(state, {
    updateUserIntegrationAccount: {
      $merge: { isLoading: false, error: '' },
    },
  });

const handleUpdateUserIntegrationAccountSuccess = (
  state: types.VersionControlState,
) =>
  ih(state, {
    updateUserIntegrationAccount: {
      isLoading: { $set: false },
    },
  });

const handleUpdateUserIntegrationAccountError = (
  state: types.VersionControlState,
  action: types.UpdateUserIntegrationAccountErrorAction,
) =>
  ih(state, {
    updateUserIntegrationAccount: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleFetchVersionControlServersRequest = (
  state: types.VersionControlState,
) =>
  ih(state, {
    versionControlServers: {
      $merge: { isLoading: true, error: '', data: null },
    },
  });

const handleFetchVersionControlServersSuccess = (
  state: types.VersionControlState,
  action: types.FetchVersionControlServersSuccessAction,
) =>
  ih(state, {
    versionControlServers: {
      $merge: { isLoading: false, data: action.payload.data },
    },
  });

const handleFetchVersionControlServersError = (
  state: types.VersionControlState,
  action: types.FetchVersionControlServersErrorAction,
) =>
  ih(state, {
    versionControlServers: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleFetchUserGroupsRequest = (state: types.VersionControlState) =>
  ih(state, {
    userGroups: {
      $merge: { isLoading: true, data: null },
    },
  });

const handleFetchUserGroupsSuccess = (
  state: types.VersionControlState,
  action: types.FetchUserGroupsSuccessAction,
) =>
  ih(state, {
    userGroups: {
      $merge: { isLoading: false, data: action.payload.data },
    },
  });

const handleFetchUserGroupsError = (
  state: types.VersionControlState,
  action: types.FetchUserGroupsErrorAction,
) =>
  ih(state, {
    userGroups: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleFetchProjectInfoRequest = (state: types.VersionControlState) =>
  ih(state, {
    projectInfo: {
      $merge: { isLoading: true, data: null },
    },
  });

const handleFetchProjectInfoSuccess = (
  state: types.VersionControlState,
  action: types.FetchProjectInfoSuccessAction,
) =>
  ih(state, {
    projectInfo: {
      $merge: { isLoading: false, data: action.payload.data },
    },
  });

const handleFetchProjectInfoError = (
  state: types.VersionControlState,
  action: types.FetchProjectInfoErrorAction,
) =>
  ih(state, {
    projectInfo: {
      $merge: { isLoading: false, error: action.payload.error },
    },
  });

const handleResetProjectInfo = (state: types.VersionControlState) =>
  ih(state, {
    projectInfo: { $set: initialState.projectInfo },
  });

export default (
  state = initialState,
  // @ts-ignore
  action: types.VersionControlActionTypes = {},
): types.VersionControlState => {
  switch (action.type) {
    case actionTypes.CREATE_USER_INTEGRATION_ACCOUNT_REQUEST:
      return handleCreateUserIntegrationAccountRequest(state);

    case actionTypes.FETCH_USER_INTEGRATION_ACCOUNTS_REQUEST:
      return handleFetchUserIntegrationAccountsRequest(state);

    case actionTypes.FETCH_USER_INTEGRATION_ACCOUNTS_SUCCESS:
      return handleFetchUserIntegrationAccountsSuccess(state, action);

    case actionTypes.FETCH_USER_INTEGRATION_ACCOUNTS_ERROR:
      return handleFetchUserIntegrationAccountsError(state, action);

    case actionTypes.CREATE_USER_INTEGRATION_ACCOUNT_SUCCESS:
      return handleCreateUserIntegrationAccountSuccess(state);

    case actionTypes.CREATE_USER_INTEGRATION_ACCOUNT_ERROR:
      return handleCreateUserIntegrationAccountError(state, action);

    case actionTypes.UPDATE_USER_INTEGRATION_ACCOUNT_REQUEST:
      return handleUpdateUserIntegrationAccountRequest(state);

    case actionTypes.UPDATE_USER_INTEGRATION_ACCOUNT_SUCCESS:
      return handleUpdateUserIntegrationAccountSuccess(state);

    case actionTypes.UPDATE_USER_INTEGRATION_ACCOUNT_ERROR:
      return handleUpdateUserIntegrationAccountError(state, action);

    case actionTypes.FETCH_VERSION_CONTROL_SERVERS_REQUEST:
      return handleFetchVersionControlServersRequest(state);

    case actionTypes.FETCH_VERSION_CONTROL_SERVERS_SUCCESS:
      return handleFetchVersionControlServersSuccess(state, action);

    case actionTypes.FETCH_VERSION_CONTROL_SERVERS_ERROR:
      return handleFetchVersionControlServersError(state, action);

    case actionTypes.FETCH_USER_GROUPS_REQUEST:
      return handleFetchUserGroupsRequest(state);

    case actionTypes.FETCH_USER_GROUPS_SUCCESS:
      return handleFetchUserGroupsSuccess(state, action);

    case actionTypes.FETCH_USER_GROUPS_ERROR:
      return handleFetchUserGroupsError(state, action);

    case actionTypes.FETCH_PROJECT_INFO_REQUEST:
      return handleFetchProjectInfoRequest(state);

    case actionTypes.FETCH_PROJECT_INFO_SUCCESS:
      return handleFetchProjectInfoSuccess(state, action);

    case actionTypes.FETCH_PROJECT_INFO_ERROR:
      return handleFetchProjectInfoError(state, action);

    case actionTypes.RESET_PROJECT_INFO:
      return handleResetProjectInfo(state);

    default:
      return state;
  }
};
